import { render, staticRenderFns } from "./AuditableEntity.vue?vue&type=template&id=fac6c2ca&scoped=true&"
import script from "./AuditableEntity.vue?vue&type=script&lang=js&"
export * from "./AuditableEntity.vue?vue&type=script&lang=js&"
import style0 from "./AuditableEntity.vue?vue&type=style&index=0&id=fac6c2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac6c2ca",
  null
  
)

export default component.exports